// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tagsinput {
  color: #52616A;
  background-color: #fff;
  border: 1px solid #C9D6DE;
  display: inline-block;
  padding: 4px 6px;
  vertical-align: middle;
  max-width: 100%;
  line-height: 34px;
  cursor: text;
}
.tagsinput input {
  border: none;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  padding: 0 6px;
  margin: 0;
  width: auto;
  max-width: inherit;
  height: 24px;
  display: inline-block;
  vertical-align: middle;
}
.tagsinput .tag {
  margin-right: 2px;
  color: white;
}
.taglabel-info {
  background-color: #5bc0de;
}
.taglabel {
  display: inline-block;
  padding: 3px 5px;
  line-height: 18px;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border-radius: 4px;
}
.tagsinput .tag [data-role="remove"] {
  margin-left: 5px;
  cursor: pointer;
}
.tagsinput .tag [data-role="remove"]:after {
  content: "x";
  padding: 0px 2px;
}
`, "",{"version":3,"sources":["webpack://./client/components/styles/tagsInput.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,cAAc;EACd,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".tagsinput {\n  color: #52616A;\n  background-color: #fff;\n  border: 1px solid #C9D6DE;\n  display: inline-block;\n  padding: 4px 6px;\n  vertical-align: middle;\n  max-width: 100%;\n  line-height: 34px;\n  cursor: text;\n}\n.tagsinput input {\n  border: none;\n  box-shadow: none;\n  outline: none;\n  background-color: transparent;\n  padding: 0 6px;\n  margin: 0;\n  width: auto;\n  max-width: inherit;\n  height: 24px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.tagsinput .tag {\n  margin-right: 2px;\n  color: white;\n}\n.taglabel-info {\n  background-color: #5bc0de;\n}\n.taglabel {\n  display: inline-block;\n  padding: 3px 5px;\n  line-height: 18px;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border-radius: 4px;\n}\n.tagsinput .tag [data-role=\"remove\"] {\n  margin-left: 5px;\n  cursor: pointer;\n}\n.tagsinput .tag [data-role=\"remove\"]:after {\n  content: \"x\";\n  padding: 0px 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
